import type { LeagueStudentRef } from "@core/league/types";
import { cn } from "@design-system/utils";
import { useImageLoadFailed } from "@app/shared/hooks/use-image-load-failed.hook";

const palette = [
  "bg-rose-200 text-rose-900",
  "bg-lime-200 text-lime-900",
  "bg-sky-200 text-sky-900",
  "bg-orange-200 text-orange-900",
  "bg-violet-200 text-violet-900",
  "bg-cyan-200 text-cyan-900",
  "bg-yellow-200 text-yellow-900",
  "bg-fuchsia-200 text-fuchsia-900",
];

/** Round avatar: the student's image, or a coloured initial (stable per id) when there is none or it fails to load. */
export function LeagueAvatar({
  student,
  className,
}: {
  student: LeagueStudentRef;
  className?: string;
}) {
  const initial = Array.from(student.name.trim())[0] ?? "?";
  const url = student.image?.url;
  const image = useImageLoadFailed(url);

  return url && !image.failed ? (
    <img
      ref={image.ref}
      onError={image.onError}
      alt=""
      className={cn("h-10 w-10 shrink-0 rounded-full object-cover", className)}
      loading="lazy"
      src={url}
    />
  ) : (
    <span
      aria-hidden="true"
      className={cn(
        "grid h-10 w-10 shrink-0 place-items-center rounded-full text-sm font-black",
        palette[Math.abs(student.id) % palette.length],
        className,
      )}
    >
      {initial}
    </span>
  );
}
